export const canManageAdventureChecklist = (userId?: string | null, organiserId?: string | null) =>
  Boolean(userId && organiserId && userId === organiserId);

export const canTickAdventureChecklist = (
  userId?: string | null,
  organiserId?: string | null,
  membershipStatus?: string | null
) => Boolean(userId && (userId === organiserId || membershipStatus === 'joined'));

export const getAdventureChecklistSummary = (taskCount: number, completedCount: number) =>
  taskCount > 0 ? `${completedCount} of ${taskCount} checked off` : null;

export const getAdventureChecklistGuidance = (
  canManage: boolean,
  canTick: boolean,
  hasTasks: boolean
) => {
  if (canManage) {
    return hasTasks
      ? 'Add anything else that needs sorting. Joined members can tick items off as they are done.'
      : 'Add the first task so everyone knows what still needs sorting.';
  }

  if (canTick) {
    return hasTasks
      ? 'Tick things off as they get sorted. Only the organiser can add new tasks.'
      : 'The organiser has not added any checklist items yet.';
  }

  return hasTasks
    ? 'Join this activity as going to tick items off.'
    : 'The organiser can add checklist items here, and joined members can tick them off.';
};
